import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import '../../../static/less/new_shopping_cart/reservation_details.css';
import { setFormVisible } from 'bookingform';
import formatCurrency from 'format-currency';
import { useNavigate } from 'react-router-dom';
import {
  setMultipleRoomSelection,
  setMultipleRoomStep,
  setNullRoomSelection,
  DEVICES,
} from '../../../actions/Booking';
import { addSelectedRoomsToCart } from '../../../actions/Cart';
import { MULTIPLE_ROOMS, CALL_CENTER_ROLE } from '../../../constants';
import { setCoinsApplied, setCoinsEntered, setMaxCoinsToApply } from '../../../actions/Loyalty';
import {
  getMaxCoinsToApply,
  convertCoinsToCurrencyUsingRoundedConversionRate,
} from '../../../utils';
import NewLoyaltyCard from '../../loyalty/NewLoyaltyCard';
import HotelTax from '../hotels/HotelTax';
import { getLangValue, toCustomCase } from '../../../utils/Generic';
import { IconComponent } from '../../ds/atoms/icons/iconComponent';
import {
  FinalRoomsAmount, getTotalsDistributionsByCategory,
  getTotalAmountsOfSelectedRoomsInUsdOrEur, getUpperLimit,
  getDifferenceFromTwoAmounts, bookingIsCoveredWithLoyaltyCoins,
} from '../utils';
import ReservationDetailsActions from '../edit-bookings/ReservationDetailsActions';

const ReservationDetailsBlock = (props, context) => {
  if (props.hotel == null) {
    return null;
  }

  const navigate = useNavigate();

  const [showSelectingRoomsMessage, setShowSelectingRoomsMessage] = useState(false);

  let rateCodePrimeroSeleccionado = null;
  let boardCodePrimeroSeleccionado = null;
  let rateCurrencyCodePrimeroSeleccionado = null;

  const scrollDownToRoomResults = () => {
    const element = document.querySelector('.TwoRoomScroll');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const onEmptyCart = () => {
    props.dispatch(setMultipleRoomSelection(null));
    props.dispatch(setMultipleRoomStep('1'));
  };

  const onRemoveRoom = (index) => {
    /*if (index === '1') {
      props.dispatch(setMultipleRoomSelection(null));
    }*/
    props.dispatch(setMultipleRoomStep(index.toString()));
    props.dispatch(setNullRoomSelection(index.toString()));
    scrollDownToRoomResults();
  };

  const getCustomRoomSelection = (customComb, roomId) => {
    const selection = customComb[roomId];
    const { room } = selection;
    return {
      roomId,
      roomCode: room.code,
      rateCode: selection.rateCode,
      boardCode: selection.boardCode,
      availId: customComb.availId,
      use: room.use_requested,
    };
  };

  const getSelectedBoard = (selectedRateCode, selectedBoardCode, roomIndex) => {
    const selection = props.multipleRoomSelection;
    if (selectedRateCode) {
      const { rates } = selection[roomIndex].room; // Accediendo a los rates del primer cuarto seleccionado
      for (let i = 0; i < rates.length; i++) {
        if (rates[i].code === selectedRateCode) {
          const { boards } = rates[i];
          for (let j = 0; j < boards.length; j++) {
            if (boards[j].code === selectedBoardCode) {
              return boards[j];
            }
          }
          break;
        }
      }
    }
    return null;
  };

  const onSelectCustom = () => {
    if (props.mostrarExtras === true) {
      props.handleBookNowClick();
    } else {
      const selection = props.multipleRoomSelection;
      const allNumericKeys = countAllNumericKeys(selection);
      const nullNumericKeys = countNullNumericKeys(selection);
      const difference = allNumericKeys - nullNumericKeys;

      if (difference === props.distributions.length) {
        onCompleteRoomSelection(selection, getCustomRoomSelection);
      } else {
        setShowSelectingRoomsMessage(true);
      }
    }
  };

  const countNullNumericKeys = (obj) => Object.keys(obj).reduce((count, key) => {
    // Usar una variable local en lugar de modificar el parámetro directamente
    let newCount = count;
    if (!Number.isNaN(Number(key)) && obj[key] === null) {
      newCount += 1;
    }
    return newCount;
  }, 0);

  const countAllNumericKeys = (obj) => Object.keys(obj).reduce((count, key) => {
    // Usar una variable local en lugar de modificar el parámetro directamente
    let newCount = count;
    if (!Number.isNaN(Number(key))) {
      newCount += 1;
    }
    return newCount;
  }, 0);

  const onChangeSearch = () => {
    props.dispatch(setFormVisible(true));
    const bookingFormContainer = document.querySelector('#BookingFormContent');
    if (bookingFormContainer) {
      bookingFormContainer.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  };

  const onCompleteRoomSelection = (combinationObj, roomMapper) => {
    let selectedRooms = [
      roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
    ];
    if (combinationObj) {
      if (combinationObj.bestRoomCodes) {
        if (combinationObj.bestRoomCodes[4]) {
          selectedRooms = [
            roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
            roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
            roomMapper(combinationObj, MULTIPLE_ROOMS.THIRD),
            roomMapper(combinationObj, MULTIPLE_ROOMS.FOURTH),
          ];
        } else if (combinationObj.bestRoomCodes[3]) {
          selectedRooms = [
            roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
            roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
            roomMapper(combinationObj, MULTIPLE_ROOMS.THIRD),
          ];
        } else if (combinationObj.bestRoomCodes[2]) {
          selectedRooms = [
            roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
            roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
          ];
        } else if (combinationObj.bestRoomCodes[1]) {
          selectedRooms = [
            roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
          ];
        }
      } else if (combinationObj[4]) {
        selectedRooms = [
          roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
          roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
          roomMapper(combinationObj, MULTIPLE_ROOMS.THIRD),
          roomMapper(combinationObj, MULTIPLE_ROOMS.FOURTH),
        ];
      } else if (combinationObj[3]) {
        selectedRooms = [
          roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
          roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
          roomMapper(combinationObj, MULTIPLE_ROOMS.THIRD),
        ];
      } else if (combinationObj[2]) {
        selectedRooms = [
          roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
          roomMapper(combinationObj, MULTIPLE_ROOMS.SECOND),
        ];
      } else if (combinationObj[1]) {
        selectedRooms = [
          roomMapper(combinationObj, MULTIPLE_ROOMS.FIRST),
        ];
      }
      props.dispatch(addSelectedRoomsToCart(selectedRooms, navigate));
    }
  };

  useEffect(() => {
    if (props.memberInfo) {
      // Realiza alguna acción cuando memberInfo esté disponible
      ApplyMaxCoinsToFinalRoomsAmount();
    }
  }, [props.memberInfo]); // Dependencia en memberInfo

  const ApplyMaxCoinsToFinalRoomsAmount = () => {
    //Ésto también está dentro de select-room-button de RoomTile

    if (props.isInBookingDetailsPage === true) {
      if (props.coinsUsedInEditingBooking != null && props.coinsUsedInEditingBooking > 0) {
        props.dispatch(setCoinsEntered(props.coinsUsedInEditingBooking));
        props.dispatch(setCoinsApplied(props.coinsUsedInEditingBooking));
        props.dispatch(setMaxCoinsToApply(props.coinsUsedInEditingBooking));
      }
    } else {
      // Si es agentCode y agentSell false y no quiso usar coins seteamos los coins usados en cero
      if (props.agentUseCoins === 'false') {
        props.dispatch(
          setCoinsEntered(0));
        props.dispatch(
          setCoinsApplied(0));
        props.dispatch(
          setMaxCoinsToApply(0));
        return;
      }

      const totalAmounts = getTotalAmountsOfSelectedRoomsInUsdOrEur(props);

      if (props.isLoyaltyUserLoggedIn && props.coinsEntered === 0 && props.memberInfo) {
        if (props.new_member === true && props.new_member_discount_percentage_activated === true) {
          const value = getUpperLimit(props);
          if (value > 0) {
            props.dispatch(
              setCoinsEntered(value));
            props.dispatch(
              setCoinsApplied(value));
            props.dispatch(
              setMaxCoinsToApply(value));
          }
        } else if (props.coinsEntered === 0) {
          if (totalAmounts.totalAmount > 0) {
            const value = getMaxCoinsToApply(totalAmounts.totalAmount, false);
            if (value > 0) {
              props.dispatch(
                setCoinsEntered(value));
              props.dispatch(
                setCoinsApplied(value));
              props.dispatch(
                setMaxCoinsToApply(value));
            }
          }
        }
      }
    }
  };

  const getFractionDigits = () => {
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva
    const fractionDigits = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    if (rateCurrencyCodePrimeroSeleccionado != null && props.hotel.round_amounts_for_display_enabled === true) {
      fractionDigits.minimumFractionDigits = rateCurrencyCodePrimeroSeleccionado === props.currency.code ? 2 : 0;
      fractionDigits.maximumFractionDigits = rateCurrencyCodePrimeroSeleccionado === props.currency.code ? 2 : 0;
    }
    return fractionDigits;
  };

  const showFinalAmount = () => {
    if (!props.hotel || !props.hotel.rooms) {
      return null;
    }
    //Cuando el usuario está logeado y está activado newMemberDiscountPercentage y newMember es true
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva
    const fractionDigits = getFractionDigits();
    return (
      <Fragment>
        <p className="current-price">
          {formatCurrency(bookingIsCoveredWithLoyaltyCoins(props).amountToPayInSelectedCurrency, {
            ...props.isInBookingDetailsPage === false ? props.currency : props.editBooking.currency,
            minimumFractionDigits: fractionDigits.minimumFractionDigits,
            maximumFractionDigits: fractionDigits.maximumFractionDigits,
          })}
        </p>
      </Fragment>
    );
  };

  const renderBookingEditBookingTotalPrice = () => {
    const fractionDigits = getFractionDigits();
    /*const loyaltyDiscountApplied = Object.keys(props.editBooking.loyalty).includes('discount_applied')
      ? props.editBooking.loyalty.discount_applied : 0;
    const totalPrice = (props.editBooking.amount - loyaltyDiscountApplied) > 0
      ? (props.editBooking.amount - loyaltyDiscountApplied) : 0;*/
    // Machacar el precio
    let totalPrice = props.editBooking.amount;
    // Cuando es SA y agentSell es true, el agente puede decidir usar la tarifa pública o la tarifa neta
    if (props.editBooking != null && props.editBooking.agent_code != null
        && props.editBooking.agent_code !== ''
        && props.editBooking.agent_sell != null && props.editBooking.agent_sell === true
        && props.editBooking.who_is_viewing === 'CLIENT') {
      totalPrice = props.editBooking.amount_public;
    }
    return (
      <Fragment>
        <p className="current-price">
          {formatCurrency(totalPrice, {
            ...props.editBooking.currency,
            minimumFractionDigits: fractionDigits.minimumFractionDigits,
            maximumFractionDigits: fractionDigits.maximumFractionDigits,
          })}
        </p>
      </Fragment>
    );
  };

  const RoomAmount = (selectedBoard, room, mostrarSinImpuestos = true) => {
    const amountObject = {
      amount: 0,
      discount: 0,
    };
    if (props.isInBookingDetailsPage === true) {
      amountObject.amount = room.amount;
      if (props.editBooking != null && props.editBooking.agent_code != null
          && props.editBooking.agent_code !== ''
          && props.editBooking.agent_sell != null && props.editBooking.agent_sell === true
          && props.editBooking.who_is_viewing === 'CLIENT') {
        amountObject.amount = room.amount_public;
      }
      // Para mostrar tarifas sin impuestos
      if (props.hotel != null && mostrarSinImpuestos) {
        if (props.hotel.percentage_total_taxes > 0) {
          amountObject.amount -= (amountObject.amount * (props.hotel.percentage_total_taxes / 100));
        }
      }
      return amountObject;
    } if (props.mostrarExtras === false) {
      if (selectedBoard != null) {
        /* Ésto regresa un objeto así:
        {
            "amount": 11941.02,
            "amount_before": 22113,
            "discount": 46,
            "promocode_discount": 0
        }*/
        amountObject.amount = selectedBoard.amount[props.currency.code].amount;
        amountObject.discount = selectedBoard.amount[props.currency.code].discount;
        // Para mostrar tarifas sin impuestos
        if (props.hotel != null && mostrarSinImpuestos) {
          if (props.hotel.percentage_total_taxes > 0) {
            amountObject.amount -= (amountObject.amount * (props.hotel.percentage_total_taxes / 100));
          }
        }
        return amountObject;
      }
    } else {
      amountObject.amount = room.amount[props.currency.code];
      const amount = room.amount[props.currency.code];
      const amount_before = room.amount_before[props.currency.code];
      // Calculate the discount amount
      const discountAmount = amount_before - amount;
      // Calculate the discount percentage
      const discountPercentage = (discountAmount / amount_before) * 100;
      amountObject.discount = parseInt(discountPercentage, 10);
      // Para mostrar tarifas sin impuestos
      if (props.hotel != null && mostrarSinImpuestos) {
        if (props.hotel.percentage_total_taxes > 0) {
          amountObject.amount -= (amountObject.amount * (props.hotel.percentage_total_taxes / 100));
        }
      }
      return amountObject;
    }
    return null;
  };

  const isUserLoggedIn = () => {
    if (props.memberInfo != null) {
      if (props.memberInfo.accountHolder != null) {
        return true;
      }
    }
    return false;
  };

  const renderFinalPriceBlock = () => {
    /*const finalCoinsApplied = (props.isEditingBooking || props.isInBookingDetailsPage === true)
      ? props.coinsUsedInEditingBooking : props.coinsApplied;*/
    //Acá ponemos la cantidad de coins que tengamos en la reserva a editar

    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva
    const fractionDigits = getFractionDigits();

    let currencyTitle = '';
    if (props.mostrarExtras && props.isInBookingDetailsPage === false) {
      if (props.cart.custom_currency_code != null) {
        currencyTitle = getLangValue(props.currencies.find((element) => element.code
          === props.cart.custom_currency_code),
        props.lang,
        'title');
      } else {
        currencyTitle = getLangValue(props.currencies.find((element) => element.code
          === props.cart.cartHotel.currency.code),
        props.lang,
        'title');
      }
    }

    if (props.isInBookingDetailsPage === true) {
      currencyTitle = props.editBooking.currency.title;
    }
    let rateUsedInBooking = rateCodePrimeroSeleccionado;
    if (!rateUsedInBooking) {
      if (props.cart.cartHotel.rooms.length > 0) {
        rateUsedInBooking = props.cart.cartHotel.rooms[0].rate.code;
      }
    }

    if (FinalRoomsAmount(props).totalAmount > 0) {
      return (
        <Fragment>
          <div className='row' style={{ marginBottom: '30px' }}>
            <div className='col-md-12'>
              <h2 className='reservation-details-blue-18' style={{
                position: 'absolute',
                width: '100%',
                borderBottom: '2px solid #2E608E',
              }}>{context.t('Price details')}</h2>
            </div>
          </div>
          {props.isInBookingDetailsPage === false && rateUsedInBooking != null
            && rateUsedInBooking.includes('NRPVP')
            && <div className='row payment-currency-block' style={{ marginTop: '30px' }}>
              <div className='col-md-12'>
                <p className='payment-currency-warning'>
                  {context.t("Select the MXN currency on the top right corner if your card was issued in Mexico, or USD if it's an international card. This helps avoid payment rejections.")}
                </p>
              </div>
            </div>
          }
          {props.isInBookingDetailsPage === false
            && <div className='row marginTopBottom20px' style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '30px',
            }}>
              <div className='col-md-6 removeSpaceMd6'>
                <p className='reservation-details-black boldText'>{context.t('Total')}</p>
              </div>
                <div className='col-md-6 removeSpaceMd6' style={{ paddingLeft: '0px' }}>
                  <p className="subtotal-price-initial">
                    {formatCurrency(FinalRoomsAmount(props).totalAmountBefore,
                      {
                        ...props.currency,
                        minimumFractionDigits: fractionDigits.minimumFractionDigits,
                        maximumFractionDigits: fractionDigits.maximumFractionDigits,
                      })}
                  </p>
                </div>
            </div>
          }
          {props.isInBookingDetailsPage === false
            && <div className='row marginTopBottom20px' style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className='col-md-6 removeSpaceMd6'>
                <p className='reservation-details-black boldText'>{context.t('Offer applied')}</p>
              </div>
              <div className='col-md-6 removeSpaceMd6' style={{ paddingLeft: '0px' }}>
                <p className="subtotal-price">
                  -{formatCurrency(getDifferenceFromTwoAmounts(props), {
                  ...props.currency,
                  minimumFractionDigits: fractionDigits.minimumFractionDigits,
                  maximumFractionDigits: fractionDigits.maximumFractionDigits,
                })}
                </p>
              </div>
            </div>
          }
          {/*
          {props.isInBookingDetailsPage === false && props.hotel.percentage_total_taxes > 0
            && <div className='row marginTopBottom20px' style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className='col-md-6 removeSpaceMd6'>
                <p className='reservation-details-black boldText'>{context.t('Rooms')}:</p>
              </div>
              <div className='col-md-6 removeSpaceMd6'>
                <p className="subtotal-price">{formatCurrency(FinalRoomsAmount(props).totalAmount,
                  {
                    ...props.currency,
                    minimumFractionDigits: fractionDigits.minimumFractionDigits,
                    maximumFractionDigits: fractionDigits.maximumFractionDigits,
                  })}</p>
              </div>
            </div>
          }
          */}
          {props.isInBookingDetailsPage === false && props.hotel.percentage_total_taxes > 0
            && <div className='row marginTopBottom20px' style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div className='col-md-6 removeSpaceMd6'>
                <p className='reservation-details-black boldText'>{context.t('Taxes')}</p>
              </div>
                <div className='col-md-6 removeSpaceMd6' style={{ paddingLeft: '0px' }}>
                  <p className="subtotal-price">
                    {formatCurrency(FinalRoomsAmount(props, null, false).totalTaxes,
                      {
                        ...props.currency,
                        minimumFractionDigits: fractionDigits.minimumFractionDigits,
                        maximumFractionDigits: fractionDigits.maximumFractionDigits,
                      })}
                  </p>
                </div>
            </div>
          }
          {props.isInBookingDetailsPage === false
          && props.isLoyaltyUserLoggedIn
          && props.new_member_discount_percentage_activated
          && props.new_member
          && FinalRoomsAmount(props).totalAmount * (props.new_member_discount_percentage / 100) > 0
            && <Fragment>
              <div className='row marginTopBottom20px' style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className='col-md-6 removeSpaceMd6'>
                  {isUserLoggedIn() && <p className='reservation-details-black boldText'>{context.t('{brand} {loyaltyLevel} Discount', { brand: (props.agentCode !== '' && props.agentSell === 'false') ? '' : props.loyaltyName, loyaltyLevel: props.memberInfo.membershipName.toUpperCase() })}</p>}
                  {props.selectedStatus === 'becomeMember' && <p className='reservation-details-black boldText'>{context.t('New Member Discount')}</p>}
                </div>
                <div className='col-md-6 removeSpaceMd6'>
                  {
                  /*
                  // REVERT SI SE NECESITA CALCULAR MEMBER RATE Y SA NET RATE TOMANDO EN CUENTA EL COSTO DE LA RESERVA
                  // SIN IMPUESTOS. AHROTIA LO TUVIMOS QUE DEJAR COMO ANTES, CALCULANDO EL MEMBER RATE Y SA NET RATE TOMANDO
                  // EL COSTO TOTAL DE LA RESERVA CON IMPUESTOS
                  // AHORITA ESTÁ ASÍ:
                  // FinalRoomsAmount(props, null, false).totalAmount * (props.new_member_discount_percentage / 100),
                  PARA QUE EL MEMBER RATE Y SA NET RATE SE CALCULE TOMANDO EN CUENTA EL COSTO DE LA RESERVA SIN
                  IMPUESTOS, USAR:
                  (FinalRoomsAmount(props, null, false).totalAmount - FinalRoomsAmount(props, null, false).totalTaxes)
                    * (props.new_member_discount_percentage / 100),
                  */
                  }
                  <p className="subtotal-price">-{formatCurrency(
                    FinalRoomsAmount(props, null, false).totalAmount * (props.new_member_discount_percentage / 100),
                    {
                      ...props.currency,
                      minimumFractionDigits: fractionDigits.minimumFractionDigits,
                      maximumFractionDigits: fractionDigits.maximumFractionDigits,
                    })}</p>
                </div>
              </div>
            </Fragment>
          }
          {props.isInBookingDetailsPage === false && props.isLoyaltyUserLoggedIn
            && props.agentSell === 'false' && props.agentUseCoins === 'true'
            && <Fragment>
              <div className='row marginTop20px marginBottom5px'
                style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className='col-md-6 removeSpaceMd6'>
                  <p className='reservation-details-black boldText'>{(props.agentCode !== '' && props.agentSell === 'false') ? '' : props.loyaltyName} {context.t('Coins')}</p>
                </div>
                <div className='col-md-6 removeSpaceMd6'>
                {props.isEditingBooking === false && (window.location.pathname !== '/thanks/'
                  && window.location.pathname !== '/booking-detail/')
                  && ((props.memberInfo != null && props.memberInfo.email !== '' && props.agentUseCoins === 'true')
                    || (props.selectedStatus === 'becomeMember'))
                  && <div style={{ marginTop: '-10px' }}><NewLoyaltyCard mostrarExtras={props.mostrarExtras}
                    soloMostrarCoins={true} shouldShowTitle={false} shouldShowOnlyImage={false}></NewLoyaltyCard>
                    {/*<p className="subtotal-price">-{formatCurrency(
                      Math.round(
                        convertCoinsToCurrencyUsingRoundedConversionRate(finalCoinsApplied) * 100) / 100,
                      {
                        ...props.currency,
                        minimumFractionDigits: fractionDigits.minimumFractionDigits,
                        maximumFractionDigits: fractionDigits.maximumFractionDigits,
                      })}
                      </p>*/}
                    </div>
                }

                {(props.isEditingBooking === true || window.location.pathname === '/thanks/'
                  || window.location.pathname === '/booking-detail/')
                  && <p className="subtotal-price">-{formatCurrency(
                    Math.round(
                      convertCoinsToCurrencyUsingRoundedConversionRate(props.coinsUsedInEditingBooking) * 100) / 100,
                    {
                      ...props.currency,
                      minimumFractionDigits: fractionDigits.minimumFractionDigits,
                      maximumFractionDigits: fractionDigits.maximumFractionDigits,
                    })}
                  </p>
                }
                </div>
              </div>
            </Fragment>
          }
          { props.isInBookingDetailsPage === false && FinalRoomsAmount(props).totalAmountExtras > 0
            && <Fragment>
              <div className='row' style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div className='col-md-6 removeSpaceMd6'>
                  <p className='reservation-details-black boldText'>{context.t('Extras')}</p>
                </div>
                <div className='col-md-6 removeSpaceMd6'>
                  <p className="subtotal-price">+{formatCurrency(
                    FinalRoomsAmount(props).totalAmountExtras,
                    {
                      ...props.currency,
                      minimumFractionDigits: fractionDigits.minimumFractionDigits,
                      maximumFractionDigits: fractionDigits.maximumFractionDigits,
                    })}</p>
                </div>
              </div>
            </Fragment>
          }
          <div className='row finalPriceBlock' style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className='col-md-6 removeSpaceMd6'>
              <p className='reservation-details-black-final-price'>* {context.t('FINAL PRICE')}:</p>
            </div>
            <div className='col-md-6 removeSpaceMd6'>
              {props.isInBookingDetailsPage === false && (
                <>
                  {showFinalAmount()}
                </>
              )}
              {props.isInBookingDetailsPage === true && renderBookingEditBookingTotalPrice()}
            </div>
          </div>

          {props.mostrarExtras
          && <Fragment>
            {props.isInBookingDetailsPage === true
            && <Fragment>
              <p className='finalAmpuntToBeChargedText'>{context.t('Note: The final amount of your reservation will be charged in')} {currencyTitle} {context.t('equivalent to')}:</p>
              <p className='current-price'>
                {renderBookingEditBookingTotalPrice()}
              </p>
            </Fragment>
            }
          </Fragment>}

          <p className='taxesIncludedText'>*{context.t('Taxes included')}</p>
          <p className='taxesIncludedText'>
            {props.isInBookingDetailsPage === false
              && <HotelTax hotel={props.hotel} lang={props.lang}/>
            }
            {props.isInBookingDetailsPage === true
              && <HotelTax special_tax_text={props.editBooking.special_tax_text}/>
            }
          </p>
          {props.isInBookingDetailsPage === false
          && props.agentCode !== '' && props.agentSell === 'true' && props.rateType === 'NET_RATE'
          && <p className='taxesIncludedText' style={{ color: '#A0A0A0' }}>
            {context.t('You have chosen a net rate. This means that your commission is already automatically included in the public rate, so you will not have to take any additional steps to receive it.')}
            </p>
          }
          {props.isInBookingDetailsPage === false
          && props.agentCode !== '' && props.agentSell === 'true' && props.rateType === 'PUBLIC_RATE'
          && <p className='taxesIncludedText' style={{ color: '#A0A0A0' }}>
            {context.t('You have chosen a public rate. In this case, you will need to arrange your commission directly with the Sandos team in order to receive payment.')}
            </p>
          }
          {props.isInBookingDetailsPage === true
          && props.agentCode !== '' && props.agentSell === 'true' && props.rateType === 'NET_RATE'
          && props.editBooking.who_is_viewing === 'AGENT'
          && <p className='taxesIncludedText' style={{ color: '#A0A0A0' }}>
            {context.t('You have chosen a net rate. This means that your commission is already automatically included in the public rate, so you will not have to take any additional steps to receive it.')}
            </p>
          }
          {props.isInBookingDetailsPage === true
          && props.agentCode !== '' && props.agentSell === 'true' && props.rateType === 'PUBLIC_RATE'
          && props.editBooking.who_is_viewing === 'AGENT'
          && <p className='taxesIncludedText' style={{ color: '#A0A0A0' }}>
            {context.t('You have chosen a public rate. In this case, you will need to arrange your commission directly with the Sandos team in order to receive payment.')}
            </p>
          }
        </Fragment>
      );
    }
    return (
      <Fragment>
        <p className="current-price">{formatCurrency(FinalRoomsAmount(props, null, false).totalAmount, {
          ...props.currency,
          minimumFractionDigits: fractionDigits.minimumFractionDigits,
          maximumFractionDigits: fractionDigits.maximumFractionDigits,
        })}</p>
      </Fragment>
    );
  };

  const renderExtrasSelected = (roomId) => {
    const roomExtras = (props.isInBookingDetailsPage === false)
      ? props.cart.cartHotel.rooms[roomId - 1].extras : props.editBooking.rooms[roomId - 1].extras;
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva
    const fractionDigits = getFractionDigits();
    return (
      <Fragment>
        {roomExtras.map((extra, index) => (
          <p key={index} className='reservation-details-black'>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <span style={{ width: '60%' }}>{props.isInBookingDetailsPage === false ? extra.name : extra.title}</span>
              <span style={{ width: '40%', textAlign: 'right' }} className='reservation-details-room-amount'>
              {formatCurrency(props.isInBookingDetailsPage === false
                ? extra.prices[props.currency.code].amount : extra.amount, {
                ...props.isInBookingDetailsPage === false ? props.currency : props.editBooking.currency,
                minimumFractionDigits: fractionDigits.minimumFractionDigits,
                maximumFractionDigits: fractionDigits.maximumFractionDigits,
              })}
              </span>
            </div>
          </p>
        ))}
      </Fragment>
    );
  };

  const getAppliedPromocode = () => {
    const roomData = props.multipleRoomSelection;
    let promocodeApplied = null; // Variable para almacenar el promocode

    if (roomData['1'] != null) {
      Object.keys(roomData).filter((key) => !Number.isNaN(Number(key))).forEach((key) => {
        if (roomData[key] != null) {
          const { rates } = roomData[key].room; // Accediendo a los rates del primer cuarto seleccionado
          for (let i = 0; i < rates.length; i++) {
            const { boards } = rates[i];
            for (let j = 0; j < boards.length; j++) {
              if (boards[j].promocode_applied != null) {
                promocodeApplied = boards[j].promocode_applied; // Asignar el valor a la variable
                return; // Salir del bucle
              }
            }
            if (promocodeApplied) return; // Si se encontró un promocode, salir del bucle externo
          }
        }
      });
    } else {
      const { rooms } = props.cart.cartHotel;
      rooms.forEach((room) => {
        if (room.board.promocode_applied != null) {
          promocodeApplied = room.board.promocode_applied; // Asignar el valor a la variable
        }
      });
    }

    if (promocodeApplied) {
      return promocodeApplied; // Retornar el promocode encontrado
    }
    return null; // Retorna null si no se encuentra ningún promocode
  };

  const renderPromocodeApplied = () => {
    const promocodeEntered = props.promoCode;
    const appliedPromocode = getAppliedPromocode();
    if (promocodeEntered === appliedPromocode && promocodeEntered != null && appliedPromocode != null) {
      return (
        <p>
          <span className='reservation-details-blue'>{context.t('Applied Promocode')}:</span>
          <br/>
          <span className='marginLeft10 reservation-details-black'>{appliedPromocode}</span>
        </p>
      );
    }
    return null;
  };

  const renderSelectButton = () => {
    if (props.mostrarExtras === false) {
      const buttonClass = props.isCartUpdating ? ' adding' : '';
      return (
        <button className={`continue ${buttonClass}`}
                onClick={() => onSelectCustom()} disabled={props.isCartUpdating}>
          {props.isCartUpdating ? context.t('Adding...') : props.bookNowTextButton}
        </button>
      );
    }
    if (props.isEditingBooking === true) {
      const buttonClass = props.isCreatingBooking ? ' adding' : '';
      return (
        <button className={`continue ${buttonClass}`}
                onClick={() => onSelectCustom()} disabled={props.isCreatingBooking}>
          {props.isCreatingBooking ? context.t('Wait a moment, please...') : context.t('Confirm change')}
        </button>
      );
    }
    const buttonClass = props.isCreatingBooking ? ' adding' : '';
    return (
        <button className={`continue ${buttonClass}`}
                onClick={() => onSelectCustom()} disabled={props.isCreatingBooking}>
          {props.isCreatingBooking ? context.t('Wait a moment, please...') : props.bookNowTextButton}
        </button>
    );
  };

  const Room = ({ room, index, selectedBoard }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    let roomName = '';

    if (props.mostrarExtras) {
      roomName = getLangValue(room.room, props.lang, 'name');
    } else if (room != null) {
      roomName = getLangValue(room, props.lang, 'name');
    }

    const fractionDigits = getFractionDigits();

    return (
      <div className="room">
        <div
          className="room-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span className='reservation-details-blue-18' style={{ marginRight: '0px' }}>
              {context.t('Room 0')}{index}
            </span>
            {room && <IconComponent icon={isExpanded === true ? 'chevron-up' : 'chevron-down'}
                className="room-chevron-icon"/>}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {room && (
              <div className="contenedor2Spans">
                <span
                  style={{
                    width: '100%',
                    textAlign: 'right',
                    marginRight: '15px',
                    color: '#626262',
                  }}
                  className='spanArriba reservation-details-blue-18 reservation-details-room-amount'
                >
                  {formatCurrency(RoomAmount(selectedBoard, room).amount, {
                    ...props.isInBookingDetailsPage === false ? props.currency : props.editBooking.currency,
                    minimumFractionDigits: fractionDigits.minimumFractionDigits,
                    maximumFractionDigits: fractionDigits.maximumFractionDigits,
                  })}
                </span>
                {props.hotel.percentage_total_taxes > 0
                  && <span className="spanAbajo plusTaxesText">+{context.t('Taxes')} {formatCurrency(RoomAmount(selectedBoard, room, false).amount * (props.hotel.percentage_total_taxes / 100), {
                    ...props.isInBookingDetailsPage === false ? props.currency : props.editBooking.currency,
                    minimumFractionDigits: fractionDigits.minimumFractionDigits,
                    maximumFractionDigits: fractionDigits.maximumFractionDigits,
                  })}
                  </span>
                }
                {props.hotel.percentage_total_taxes === 0
                  && <span className="spanAbajo plusTaxesText">*{context.t('Taxes included')}
                  </span>
                }
              </div>
            )}
            {!room && (
              <span
                style={{
                  width: '100%',
                  textAlign: 'right',
                  //marginRight: '15px',
                  color: 'black',
                }}
                className='reservation-details-blue-18 reservation-details-room-amount'
              >
                ----------
              </span>
            )}
          </div>
        </div>

        {isExpanded && room && (
          <div className="room-content" style={{ padding: '0px 0px 10px 0px;' }}>
            <p>
              <span
                className="reservation-details-blue-18 remove-text"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveRoom(index);
                }}
                style={{ cursor: 'pointer', fontWeight: 'normal' }}
              >
                {props.mostrarExtras === false && context.t('Edit')}
              </span>
            </p>
            <p>
              <span className='reservation-details-black'>
                {room.distribution.adults > 0 && `${room.distribution.adults} ${context.t('adults')}`}
                {room.distribution.adults > 0 && room.distribution.children > 0 && ' + '}
                {room.distribution.children > 0 && `${room.distribution.children} ${context.t('children')}`}
                {(room.distribution.adults > 0 || room.distribution.children > 0)
                 && room.distribution.infants > 0 && ' + '}
                {room.distribution.infants > 0 && `${room.distribution.infants} ${context.t('infants')}`}
              </span>
            </p>
            <p className='reservation-details-blue'>
              {context.t('Type')}:
            </p>
            <p className='reservation-details-black'>
              {roomName}
            </p>
            {props.isInBookingDetailsPage === false
              && <>
                <p className='reservation-details-blue'>
                  {context.t('Discounts')}:
                </p>
                <p className='reservation-details-black'>
                  {`-${RoomAmount(selectedBoard, room).discount}% ${context.t('Applied to this room')}`}
                </p>
              </>
            }
            {props.new_member_discount_percentage_activated && props.new_member
             && props.memberInfo != null && props.memberInfo.email !== '' && (
              <p className='reservation-details-black'>
                {`- ${context.t('{brand} {loyaltyLevel} Discount', {
                  brand: props.loyaltyName,
                  loyaltyLevel: props.memberInfo.membershipName.toUpperCase(),
                })}`
                }
              </p>
            )}
            {renderPromocodeApplied()}
            {props.mostrarExtras && (
              <Fragment>
                <p className='reservation-details-blue'>{context.t('Extras')}:</p>
                {renderExtrasSelected(index)}
              </Fragment>
            )}
          </div>
        )}
      </div>
    );
  };

  const RoomList = () => {
    let rooms = null;
    if (props.isInBookingDetailsPage === true) {
      rooms = props.editBooking.rooms;
      return (
        <div>
            {rooms.map((room, index) => (
              <Room key={index} room={room} index={index + 1} selectedBoard={room.board} />
            ))}
        </div>
      );
    }
    if (props.mostrarExtras === false) {
      rooms = props.multipleRoomSelection;
      return (
        <div>
            {Object.keys(rooms).filter((key) => !Number.isNaN(Number(key))).map((key) => {
              if (key > props.distributions.length) {
                return null;
              }
              const room = rooms[key];
              let selectedBoard = null;
              if (room != null) {
                selectedBoard = getSelectedBoard(rateCodePrimeroSeleccionado, boardCodePrimeroSeleccionado, key);
              }
              return <Room key={key} room={room ? room.room : null} index={key} selectedBoard={selectedBoard} />;
            })}
        </div>
      );
    }
    rooms = props.cart.cartHotel.rooms;
    return (
      <div>
          {rooms.map((room, index) => (
            <Room key={index} room={room} index={index + 1} selectedBoard={room.board} />
          ))}
      </div>
    );
  };

  const totals = getTotalsDistributionsByCategory(props);

  const roomData = props.multipleRoomSelection;

  // Iterar sobre las claves numéricas y encontrar el primer cuarto seleccionado
  const foundKey = Object.keys(roomData).find((k) => roomData[k] && roomData[k].rateCode);
  if (foundKey !== undefined) {
    rateCodePrimeroSeleccionado = roomData[foundKey].rateCode;
    boardCodePrimeroSeleccionado = roomData[foundKey].boardCode;
  } else if (props.cart.cartHotel.rooms.length > 0) {
    // Si tenemos los cuartos en el shopping cart
    // podemos sacar la información de ahí
    rateCodePrimeroSeleccionado = props.cart.cartHotel.rooms[0].rate.code;
    boardCodePrimeroSeleccionado = props.cart.cartHotel.rooms[0].board.code;
  }

  // Buscar el rate correspondiente al rateCode encontrado
  let rateNamePrimeroSeleccionado = null;

  if (rateCodePrimeroSeleccionado) {
    const firstValidRoomKey = ['1', '2', '3', '4'].find((key) => roomData[key] !== null);
    const rates = firstValidRoomKey ? roomData[firstValidRoomKey].room.rates : [];// Accediendo a los rates del primer cuarto seleccionado
    for (let i = 0; i < rates.length; i++) {
      if (rates[i].code === rateCodePrimeroSeleccionado) {
        rateNamePrimeroSeleccionado = rates[i].name;
        rateCurrencyCodePrimeroSeleccionado = rates[i].currency;
        break;
      }
    }
  }
  let boardNamePrimeroSeleccionado = null;
  if (rateCodePrimeroSeleccionado) {
    const firstValidRoomKey = ['1', '2', '3', '4'].find((key) => roomData[key] !== null);
    const rates = firstValidRoomKey ? roomData[firstValidRoomKey].room.rates : [];// Accediendo a los rates del primer cuarto seleccionado
    for (let i = 0; i < rates.length; i++) {
      if (rates[i].code === rateCodePrimeroSeleccionado) {
        const { boards } = rates[i];
        for (let j = 0; j < boards.length; j++) {
          if (boards[j].code === boardCodePrimeroSeleccionado) {
            boardNamePrimeroSeleccionado = getLangValue(boards[j], props.lang, 'name');
          }
        }
        break;
      }
    }
  }
  if (props.coinsApplied === 0) {
    //Sólo se calcula los coins applied la primera vez que se agrega un cuarto
    //porque si lo calculamos cada vez que se agrega un cuarto (cada vez que se renderiza)
    //perderíamos el valor de los coins seleccionados por el usuario
    ApplyMaxCoinsToFinalRoomsAmount();
  }

  const selection = props.multipleRoomSelection;
  const allNumericKeys = countAllNumericKeys(selection);
  const nullNumericKeys = countNullNumericKeys(selection);
  const difference = allNumericKeys - nullNumericKeys;

  let boardTypeName = null;
  let rateName = null;
  if (props.isInBookingDetailsPage) {
    boardTypeName = props.editBooking.rooms[0].board.name;
    rateName = props.editBooking.rooms[0].rate.name;
  } else if (props.mostrarExtras === false) {
    boardTypeName = boardNamePrimeroSeleccionado;
    rateName = rateNamePrimeroSeleccionado;
  } else if (props.cart.cartHotel.rooms.length > 0) {
    boardTypeName = getLangValue(props.cart.cartHotel.rooms[0].board, props.lang, 'name');
    rateName = getLangValue(props.cart.cartHotel.rooms[0].rate, props.lang, 'name');
  }

  return (
    <Fragment>
      <div className={`reservation-container ${props.openReservationDetails === false
        ? 'marginTopOpenReservationDetails' : ''}`}>
      {props.openReservationDetails === false && props.shouldShowNewShoppingCartMobileHeader === false
      && <button className="change-search" onClick={() => onChangeSearch()}>{context.t('Change Search')}</button>}
      <div className="reservation-details">
        <h2>{context.t('Reservation Details')}</h2>
        <p className='reservation-details-blue lineHeightSpecial'>{props.hotel_name}:</p>
        <p className='lineHeightSpecial'>
          <span className='reservation-details-blue'>{context.t('Stay')}:</span> <span className='reservation-details-black'>{props.checkIn} - {props.checkOut}</span>
        </p>
        <p className='lineHeightSpecial'>
          <span className='reservation-details-blue'>{context.t('Rooms')}:</span> <span className='reservation-details-black'>{props.isInBookingDetailsPage === false ? props.distributions.length : props.editBooking.rooms.length}</span>
        </p>
        <p className='lineHeightSpecial'>
          <span className='reservation-details-blue'>{context.t('People')}: </span>
          <span className='reservation-details-black'>
            {totals.adl > 0 && `${totals.adl} ${context.t('adults')}`}
            {totals.adl > 0 && totals.chd > 0 && ' + '}
            {totals.chd > 0 && `${totals.chd} ${context.t('children')}`}
            {(totals.adl > 0 || totals.chd > 0) && totals.enf > 0 && ' + '}
            {totals.enf > 0 && `${totals.enf} ${context.t('infants')}`}
          </span>
        </p>
        <p className='lineHeightSpecial'>
          <span className='reservation-details-blue'>{context.t('Board type')}:</span> <span className='reservation-details-black'>{ boardTypeName}</span>
        </p>
        <p className='lineHeightSpecial'>
        <span className='reservation-details-blue'>{context.t('Rate')}:</span> <span className='reservation-details-black'>{rateName != null ? toCustomCase(rateName) : ''}</span>
        </p>
      </div>
      {((props.memberInfo != null && props.memberInfo.email !== ''
        && props.agentUseCoins === 'true') || (props.selectedStatus === 'becomeMember'))
        && props.agentSell === 'false' && <NewLoyaltyCard mostrarExtras={props.mostrarExtras}
          soloMostrarCoins={false} shouldShowTitle={true} shouldShowOnlyImage={true}></NewLoyaltyCard>}
      <div className="rooms-and-extras">
        <h2 className='reservation-details-blue-18'>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ width: '50%' }}>{context.t('Rooms and Extras')}</span>
            <span
              className="remove-text"
              onClick={() => onEmptyCart()}
              style={{
                cursor: 'pointer', width: '50%', textAlign: 'right', fontWeight: 'normal',
              }}
            >
              { props.mostrarExtras === false && context.t('Empty Cart')}
            </span>
          </div>
        </h2>
        <RoomList />
      </div>
      <div className="final-price">
        {renderFinalPriceBlock()}
      </div>
      {difference !== props.distributions.length
        && showSelectingRoomsMessage === true
        && <span className='reservation-details-red'>{context.t('You have not selected all the rooms yet...')}</span>}
      {(props.isDesktop === true || (props.openReservationDetails === true
        && window.location.pathname === '/rooms/')) && !(window.location.pathname === '/thanks/')
        && !(window.location.pathname === '/booking-detail/')
        && renderSelectButton()}
      </div>
      {props.locator
        && <ReservationDetailsActions bookingStatus={props.bookingStatus} hotelPhone={props.hotelPhone}/>
      }
    </Fragment>
  );
};

ReservationDetailsBlock.propTypes = {
  hotel_name: PropTypes.string.isRequired,
  checkIn: PropTypes.string.isRequired,
  checkOut: PropTypes.string.isRequired,
  mostrarExtras: PropTypes.bool.isRequired,
  bookNowTextButton: PropTypes.string.isRequired,
  handleBookNowClick: PropTypes.func,
  bookingStatus: PropTypes.string, // Opcional, para que desde booking detail mandemos el status y en booking detail actions sepamos si debemos dejar editar la booking o no dependiendo de su estatus
  hotelPhone: PropTypes.string,
};

ReservationDetailsBlock.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { memberInfo } = state.loyalty;
  const isEmailPresent = Boolean(memberInfo && memberInfo.accountHolder);
  const isBecomeMemberStatus = state.loyalty.selectedStatus === 'becomeMember';

  return {
    hotel: state.booking.hotel,
    loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
    openReservationDetails: state.session.openReservationDetails,
    shouldShowNewShoppingCartMobileHeader: !!(window.location.pathname === '/rooms/'
      || window.location.pathname === '/confirmation/'
      || window.location.pathname === '/thanks/'
      || window.location.pathname === '/booking-detail/'
    ),
    multipleRoomStep: state.booking.multipleRoomStep,
    multipleRoomSelection: state.booking.multipleRoomSelection,
    cart: state.cart,
    currency: state.booking.filterCurrency,
    paymentCurrency: state.booking.paymentCurrency,
    nights: state.booking.last_requested_info.nights,
    chain: state.bookingFormState.chain,
    lang: state.i18nState.lang,
    isCreatingBooking: state.session.isCreatingBooking,
    isMobile: state.booking.device === DEVICES.MOBILE,
    isTabletV: state.booking.device === DEVICES.TABLETV,
    isTabletH: state.booking.device === DEVICES.TABLETH,
    isDesktop: state.booking.device === DEVICES.DESKTOP,
    selectedStatus: state.loyalty.selectedStatus,
    conversionRates: state.loyalty.conversionRates,
    distributions: state.bookingFormState.distributions.length > 0
      ? state.bookingFormState.distributions
      : state.cart.cartHotel.rooms.map((room) => room.distribution),
    coinsApplied: state.loyalty.coinsApplied,
    coinsEntered: state.loyalty.coinsEntered,
    isLoyaltyUserLoggedIn: isEmailPresent || isBecomeMemberStatus,
    new_member: state.loyalty.newMember,
    new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
    new_member_discount_percentage_activated: state.booking.hotel != null
      ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
    isCartUpdating: state.cart.isUpdating,
    currencies: state.booking.currencies,
    loggedUser: state.loyalty.loggedUser,
    memberInfo,
    maxPercentUsage: state.loyalty.maxPercentUsage,
    promoCode: state.bookingFormState.promoCode,
    locator: state.booking.book_locator,
    isEditingBooking: state.booking.isEditingBooking,
    coinsUsedInEditingBooking: state.booking.coinsUsedInEditingBooking,
    editBooking: state.booking.editBooking,
    isInBookingDetailsPage: window.location.pathname.includes('/thanks/')
    || window.location.pathname.includes('/my-booking/')
    || window.location.pathname.includes('/booking-detail/'),
    isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
    agentCode: state.bookingFormState.agentCode,
    agentSell: state.bookingFormState.agentSell,
    rateType: state.booking.rateType,
    agentUseCoins: state.booking.agentUseCoins,
    saNetRatepercentage: state.loyalty.saNetRatepercentage,
  };
};

export default connect(mapStateToProps)(ReservationDetailsBlock);
